import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaioutstationcabbooking() {



const cardData =
{
  keyword: 'Mumbai Outstation Cab Booking',

  heading: 'Lotus Cab: Mumbai Outstation Cab Booking',

headingDescription:
    "Lotus Cabs provides reliable and affordable Mumbai Outstation Cab Booking services for family vacations, business travel, corporate tours, pilgrimage journeys, weekend getaways, airport transfers, sightseeing, and one-way or round-trip travel across Maharashtra and India. Our fleet includes Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus, all driven by professional and experienced chauffeurs. With 24x7 booking assistance, transparent pricing, doorstep pickup anywhere in Mumbai, well-maintained vehicles, and safe long-distance travel, Lotus Cabs ensures a comfortable, convenient, and hassle-free outstation cab experience for every journey.",

  top: 'Top Outstation Destinations from Mumbai with Lotus Cab',

 keyword: "Mumbai Outstation Cab Booking",

headingDescription:
    "Lotus Cabs provides reliable and affordable Mumbai Outstation Cab Booking services for family vacations, business travel, corporate tours, pilgrimage journeys, weekend getaways, airport transfers, sightseeing, and one-way or round-trip travel across Maharashtra and India. Our fleet includes Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus, all driven by professional and experienced chauffeurs. With 24x7 booking assistance, transparent pricing, doorstep pickup anywhere in Mumbai, well-maintained vehicles, and safe long-distance travel, Lotus Cabs ensures a comfortable, convenient, and hassle-free outstation cab experience for every journey.",

topPlaces: [
    {
        title: "Pune",
        description:
            "Pune is one of the most frequently booked outstation destinations from Mumbai, attracting business travelers, students, families, and tourists throughout the year. The city is known for its IT parks, educational institutions, historical monuments, shopping destinations, and vibrant food culture. Lotus Cabs provides comfortable one-way and round-trip cab services for a smooth and enjoyable journey from Mumbai to Pune."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is a popular hill station located between Mumbai and Pune, famous for its scenic valleys, waterfalls, Bhushi Dam, Tiger Point, Karla Caves, and pleasant climate. It is a preferred weekend getaway for families, couples, and corporate groups looking to enjoy nature and relax amidst the beautiful Sahyadri Hills."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is one of Maharashtra's most beautiful hill stations, renowned for its strawberry farms, Venna Lake, scenic viewpoints, waterfalls, and cool weather. Travelers from Mumbai choose Lotus Cabs for comfortable road trips to enjoy family vacations, honeymoon holidays, and sightseeing in the picturesque Western Ghats."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is one of India's most important pilgrimage destinations, drawing millions of devotees to the sacred Sai Baba Temple every year. Lotus Cabs offers reliable Mumbai outstation cab services for Sai Baba Darshan, family pilgrimages, and religious tours with flexible one-way and round-trip travel options."
    },
    {
        title: "Nashik",
        description:
            "Nashik is a leading spiritual and wine tourism destination, famous for Trimbakeshwar Jyotirlinga, Panchavati, Ram Kund, Sula Vineyards, and the Kumbh Mela. Whether you're planning a pilgrimage, vineyard tour, or family holiday, Lotus Cabs ensures a safe and comfortable journey from Mumbai."
    },
    {
        title: "Goa",
        description:
            "Goa is India's most popular beach destination, known for its golden beaches, Portuguese heritage, vibrant nightlife, water sports, churches, and luxury resorts. Lotus Cabs provides comfortable long-distance cab services from Mumbai to Goa, making every road trip enjoyable for families, couples, and groups."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is famous for the sacred Mahalaxmi Temple, Panhala Fort, Rankala Lake, authentic cuisine, and rich Maratha heritage. Travelers frequently book Mumbai outstation cabs for pilgrimage tours, cultural visits, and family holidays to explore this historic city."
    },
    {
        title: "Aurangabad (Chhatrapati Sambhajinagar)",
        description:
            "Aurangabad is home to the UNESCO World Heritage Sites of Ajanta and Ellora Caves, Grishneshwar Jyotirlinga, Bibi Ka Maqbara, and Daulatabad Fort. It is one of Maharashtra's most visited heritage destinations and an ideal choice for history lovers, pilgrims, and sightseeing enthusiasts."
    },
    {
        title: "Ratnagiri",
        description:
            "Ratnagiri is a scenic coastal destination in the Konkan region, famous for Ganpatipule Temple, pristine beaches, Alphonso mango orchards, sea forts, and breathtaking coastal drives. Lotus Cabs offers relaxing outstation taxi services from Mumbai for families and nature lovers exploring the Konkan coast."
    },
    {
        title: "Saputara",
        description:
            "Saputara, Gujarat's only hill station, is a favorite destination for travelers from Mumbai seeking cool weather, beautiful lakes, waterfalls, ropeway rides, and panoramic viewpoints. The peaceful atmosphere and scenic mountain roads make it an ideal weekend getaway for families, couples, and adventure enthusiasts."
    }
],

  "services": [
    {
      "name": "Mumbai Outstation Cab Booking",
      "description": "Book Mumbai outstation cab booking for reliable and safe intercity travel to major destinations across Maharashtra and neighboring states. Available for one-way drop, round-trip taxi, and multi-day rental plans. AC sedan, Ertiga, Innova Crysta, SUV, luxury cars, and Tempo Traveller options are offered depending on group size and comfort preference. Transparent per kilometer pricing includes base fare, driver allowance, toll charges, and minimum daily usage details. Professional drivers experienced in highway and long-distance travel ensure punctual pickup and safe arrival. Suitable for family trips, corporate travel, pilgrimage journeys, and leisure vacations."
    },
    {
      "name": "Mumbai Outstation One Way Cab",
      "description": "Affordable Mumbai outstation one way cab option allows travelers to pay only for single-side distance without return charges. Ideal for airport transfers, relocation travel, and business visits. Vehicles are maintained for long highway drives with AC comfort and ample luggage space. Fare structure is clearly explained before trip confirmation."
    },
    {
      "name": "Mumbai Outstation Round Trip Taxi",
      "description": "Round trip taxi service from Mumbai available with flexible return schedule and multi-day rental options. Suitable for weekend getaways, temple visits, and corporate travel. Comfortable vehicles ensure smooth long-distance experience."
    },
    {
      "name": "Outstation Cab from Mumbai Airport",
      "description": "Direct outstation cab pickup from Mumbai Airport (T1 & T2) for seamless intercity travel. Timely arrival and luggage support ensure stress-free departure."
    },
    {
      "name": "Mumbai Outstation Innova Cab",
      "description": "Premium Innova Crysta outstation cab from Mumbai offering spacious seating and enhanced comfort for families and corporate groups."
    },
    {
      "name": "Mumbai Outstation Ertiga Cab",
      "description": "Budget-friendly Ertiga cab suitable for small families and economical intercity travel."
    },
    {
      "name": "Mumbai Outstation SUV Taxi",
      "description": "SUV taxi option for long-distance travel providing extra luggage capacity and road stability."
    },
    {
      "name": "Mumbai Outstation Tempo Traveller",
      "description": "Tempo Traveller available for larger groups, corporate outings, and pilgrimage tours with comfortable seating."
    }
  ],

  "tableData": [
    ["Mumbai Outstation Cab Booking", "Mumbai Outstation One Way Cab"],
    ["Mumbai Outstation Round Trip Taxi", "Outstation Cab from Mumbai Airport"],
    ["Mumbai Outstation Innova Cab", "Mumbai Outstation Ertiga Cab"],
    ["Mumbai Outstation SUV Taxi", "Mumbai Outstation Tempo Traveller"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Reliable Intercity Travel",
      "WhyChoosedescription": "Safe and smooth long-distance journeys from Mumbai with experienced drivers."
    },
    {
      "WhyChooseheading": "Transparent Per KM Pricing",
      "WhyChoosedescription": "Clear billing structure including tolls and driver allowance."
    },
    {
      "WhyChooseheading": "One Way & Round Trip Flexibility",
      "WhyChoosedescription": "Flexible booking options suitable for all travel needs."
    },
    {
      "WhyChooseheading": "Airport Pickup Convenience",
      "WhyChoosedescription": "Direct pickup from Mumbai Airport terminals."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options",
      "WhyChoosedescription": "Sedan, SUV, Innova, Ertiga, luxury car, and Tempo Traveller options."
    },
    {
      "WhyChooseheading": "Comfortable AC Vehicles",
      "WhyChoosedescription": "Well-maintained vehicles ensuring relaxed highway travel."
    },
    {
      "WhyChooseheading": "Professional Drivers",
      "WhyChoosedescription": "Highway-trained chauffeurs ensuring punctual and safe service."
    },
    {
      "WhyChooseheading": "24/7 Booking Support",
      "WhyChoosedescription": "Round-the-clock assistance for booking and fare queries."
    }
  ]
}










const faqData = [
  {
    question: 'Does Lotus Cab provide Mumbai outstation cab booking service?',
    answer: 'Yes, Lotus Cab offers reliable Mumbai outstation cab booking services for one-way and round trips to major destinations across Maharashtra, Gujarat, Goa, and nearby states.',
  },
  {
    question: 'How can I book an outstation cab from Mumbai?',
    answer: 'You can book a Mumbai outstation cab by sharing your pickup location, destination, travel date, passenger count, and preferred vehicle type to receive instant fare details and confirmation.',
  },
  {
    question: 'What are the charges for Mumbai outstation cab booking?',
    answer: 'Charges depend on distance, vehicle category (Sedan or SUV), and trip type (one-way or round trip). Lotus Cab offers transparent per km pricing with no hidden costs.',
  },
  {
    question: 'Can I book a one-way outstation cab from Mumbai?',
    answer: 'Yes, Lotus Cab provides affordable one-way outstation cab services from Mumbai so customers only pay for the drop without return fare.',
  },
  {
    question: 'Which vehicles are available for Mumbai outstation travel?',
    answer: 'We provide Sedan cars like Dzire and Etios, and spacious SUVs like Ertiga and Innova Crysta for comfortable long-distance journeys.',
  },
  {
    question: 'Is Mumbai outstation cab service available for airport pickup?',
    answer: 'Yes, Lotus Cab offers direct pickup from Mumbai Airport for outstation travel with timely arrival and professional service.',
  },
  {
    question: 'Are toll and state border charges included in the fare?',
    answer: 'Toll, parking, and state border taxes are charged separately as per actuals. Lotus Cab ensures complete pricing transparency before booking confirmation.',
  },
  {
    question: 'Is night travel available for Mumbai outstation routes?',
    answer: 'Yes, Lotus Cab provides safe and secure night travel options with experienced drivers for long-distance highway routes.',
  },
  {
    question: 'Can I book a multi-day outstation cab from Mumbai?',
    answer: 'Absolutely. Lotus Cab offers flexible multi-day packages for family vacations, business trips, pilgrimage tours, and sightseeing travel.',
  },
  {
    question: 'Is advance booking recommended for Mumbai outstation cab?',
    answer: 'Yes, advance booking is recommended, especially during weekends and festive seasons, to ensure vehicle availability and the best pricing.',
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aditya Mehta',
    feedback: 'Booked Mumbai outstation cab with Lotus Cab for a weekend trip. Smooth booking process, clean vehicle, and very professional driver.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Radhika Shah',
    feedback: 'Excellent outstation cab service from Mumbai. Transparent pricing and on-time pickup from airport. Highly recommended Lotus Cab.',
    rating: 5,
  },
];












































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];






const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai Outstation Cab Booking",
"image": "https://lotuscab.com/assets/images/mumbai-outstation-cab-booking.jpg",
"description": "Book Mumbai Outstation Cab Booking with Lotus Cab for safe, comfortable, and affordable intercity travel. One way and round trip outstation taxi service with Sedan, SUV, and AC cabs available 24x7 with professional drivers.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7694"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹11/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/mumbai-outstation-cab-booking"
}
};












  return (
    <div>
      <Helmet>
  <title>Mumbai Outstation Cab Booking | One Way & Round Trip Taxi | +91 8767592195</title>

<meta
 name="description"
 content="Book Mumbai Outstation Cab Booking with Lotus Cab for reliable intercity travel. One way and round trip taxi service with Sedan, SUV, and AC cabs, experienced drivers, instant booking, and 24x7 customer support."
/>

<meta
 name="keywords"
 content="Mumbai Outstation Cab Booking, Mumbai Outstation Cab, Mumbai Outstation Taxi, Outstation Taxi Mumbai, One Way Cab Mumbai Outstation, Round Trip Cab Mumbai Outstation, Mumbai to Pune Cab, Mumbai to Nashik Cab, Mumbai to Goa Cab, Mumbai to Shirdi Cab, Affordable Outstation Cab Mumbai, Cheap Outstation Taxi Mumbai, Online Mumbai Cab Booking, Sedan Outstation Cab Mumbai, SUV Outstation Cab Mumbai, Best Mumbai Outstation Cab, Lotus Cab Mumbai"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>








 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/82.png' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaioutstationcabbooking;